<div *ngIf="isImpersonated" class="aza-rws-impersonated-banner aza-centered-text aza-rws-rounded-red-border">
    <span class="aza-rws-impersonated-banner-text aza-text aza-text-error" translate>IMPERSONATED_BANNER_TEXT</span>
</div>

<div id="dynamic-content-container" class="dynamic-content-container main-header-container">
    <div *ngIf="profileFlags.showSideMenu" class="profile side-menu-container">
        <div class="side-menu-close-button-container">
            <button (click)="toggleProfileMenu()" class="side-menu-close-button">
                <img src="./assets/img/clear_black_24dp.svg" />
            </button>
        </div>
        <div class="side-menu-items-container">
            <section *ngFor="let item of sideMenuItems" (click)="sideMenuItemClicked(item)"
                class="side-menu-item aza-section aza-theme">
                <div class="aza-section-content">{{item.text}}</div>
            </section>
        </div>
    </div>
    <div *ngIf="profileFlags.showLogin" class="profile modal-dialog profile-control-container profile-control-login">
        <aza-rws-profile-login [eventId]="eventId" (loggedIn)="onLoggedIn($event)"
            (accountReset)="onAccountReset($event)" (closed)="onProfileControlClosed()">
        </aza-rws-profile-login>
    </div>
    <div *ngIf="profileFlags.showEvents" class="profile modal-dialog profile-control-container profile-control-events">
        <aza-rws-profile-events [eventType]="eventType" [restrictToEventId]="eventListRestrictToEventId"
            (eventClicked)="onAnotherEventClicked($event)" (closed)="onProfileControlClosed()">
        </aza-rws-profile-events>
    </div>
    <div *ngIf="profileFlags.showChangePassword"
        class="profile modal-dialog profile-control-container profile-control-change-password">
        <aza-rws-profile-change-password (closed)="onProfileControlClosed()"></aza-rws-profile-change-password>
    </div>
    <div *ngIf="profileFlags.showSubscriptions"
        class="profile modal-dialog profile-control-container profile-control-subscriptions">
        <aza-rws-profile-subscriptions (closed)="onProfileControlClosed()"></aza-rws-profile-subscriptions>
    </div>
    <div *ngIf="profileFlags.showProfile"
        class="profile modal-dialog profile-control-container profile-control-profile-page">
        <aza-rws-profile-profile-page (closed)="onProfileControlClosed()"></aza-rws-profile-profile-page>
    </div>
    <div *ngIf="profileFlags.showOrders" class="profile modal-dialog profile-control-container profile-control-orders">
        <aza-rws-profile-orders (closed)="onProfileControlClosed()"></aza-rws-profile-orders>
    </div>
    <div *ngIf="profileFlags.showContacts"
        class="profile modal-dialog profile-control-container profile-control-contacts">
        <aza-rws-profile-contacts (closed)="onProfileControlClosed()"></aza-rws-profile-contacts>
    </div>
</div>

<div id="dynamic-content-container" aza-dynamic-content-container class="dynamic-content-container"></div>

<div id="notifications-container" class="notifications-container" style="display:none;"></div>

<div id="aza-rws-shopping-cart-v1-component-container" class="aza-rws-shopping-cart-v1-component-container">
    <aza-rws-shopping-cart-v1></aza-rws-shopping-cart-v1>
</div>

<div id="aza-rws-shopping-cart-v2-component-container" class="aza-rws-shopping-cart-v2-component-container">
    <aza-rws-shopping-cart-v2 (shoppingCartChanged)="onShoppingCartChanged(getShoppingCartDataFromV2($event))"
        [data]="shoppingCartV2Data" [productsVisibility]="shoppingCartProductsVisibility"
        [dependencyResult]="applyDependenciesResult">
    </aza-rws-shopping-cart-v2>
</div>

<div id="aza-rws-activities-component-container" class="aza-rws-activities-component-container">
    <aza-rws-activities [eventSettings]="eventSettings" [showActivitiesList]="showActivitiesListSubject">
    </aza-rws-activities>
</div>

<div id="aza-rws-activities-cart-component-container" class="aza-rws-activities-cart-component-container">
    <aza-rws-activities-cart [eventSettings]="eventSettings" [showActivitiesCart]="showActivitiesCartSubject"
        [activitiesCartDisplayType]="activitiesCartDisplayType" [locked]="isActivitiesCartLocked"
        [showAddToCalendar]="activitiesCartShowAddToCalendar" [hideAvailablePlacesLeft]="activitiesCartHideAvailablePlacesLeft" (activitiesChanged)="onActivitiesCartChanged($event)">
    </aza-rws-activities-cart>
</div>

<div id="aza-rws-my-events-component-container" class="aza-rws-my-events-component-container display-none">
    <div aza-rws-my-events-container class="aza-rws-my-events-container">
        <aza-rws-table aza-rws-my-events-table [data$]="myEventsData.dataSubject"
            [rowActionGetter]="myEventsData.rowActionGetter" (pageRequested)="onMyEventsPageRequested($event)"
            (sortRequested)="onMyEventsSortRequested($event)"
            class="aza-rws-my-events-table">
            <div aza-table-action-header-cell-content
                class="aza-rws-my-events-table-action-header-cell aza-horizontal-stack aza-flex-wrap">
                <aza-rws-toggle-button (toggledChanged)="onMyEventsDateConversionToggled($event)"
                    [notToggledText]="'SHOW_IN_MY_TIME' | translate" [toggledText]="'SHOW_IN_EVENT_TIME' | translate"
                    toggledClassNames="aza-rws-my-events-table-action-header-cell-show-in-event-time"
                    notToggledClassNames="aza-rws-my-events-table-action-header-cell-show-in-my-time"
                    classNames="aza-rws-my-events-table-header-button aza-rws-my-events-table-action-header-cell-date-conversion-toggle">
                </aza-rws-toggle-button>
                <aza-rws-toggle-button
                    *ngIf="myEventsData.isOrganizationManager && myEventsData.companyManagerDependencyResult"
                    (toggledChanged)="impersonateAnotherUserByEmail()" [text]="'ADD_TO_EVENT' | translate"
                    classNames="aza-rws-my-events-table-header-button aza-rws-my-events-table-action-header-cell-add-to-event-button">
                </aza-rws-toggle-button>
            </div>
            <div aza-table-card-view-action-bar-content
                class="aza-table-card-view-action-bar-content aza-horizontal-stack aza-flex-wrap">
                <aza-rws-toggle-button (toggledChanged)="onMyEventsDateConversionToggled($event)"
                    [notToggledText]="'SHOW_IN_MY_TIME' | translate" [toggledText]="'SHOW_IN_EVENT_TIME' | translate"
                    toggledClassNames="aza-table-card-view-action-bar-content-show-in-event-time"
                    notToggledClassNames="aza-table-card-view-action-bar-content-show-in-my-time"
                    classNames="aza-table-card-view-action-bar-content-button aza-table-card-view-action-bar-content-date-conversion-toggle">
                </aza-rws-toggle-button>
                <aza-rws-toggle-button
                    *ngIf="myEventsData.isOrganizationManager && myEventsData.companyManagerDependencyResult"
                    (toggledChanged)="impersonateAnotherUserByEmail()" [text]="'ADD_TO_EVENT' | translate"
                    classNames="aza-table-card-view-action-bar-content-button aza-table-card-view-action-bar-content-add-to-event-button">
                </aza-rws-toggle-button>
            </div>
            <div aza-rws-table-no-data-template class="aza-rws-my-events-table-no-data-container"></div>
        </aza-rws-table>
    </div>
</div>

<div id="monerisCheckout" class="moneris-checkout-wrapper"></div>

<div id="dynamic-content-container" class="dynamic-content-container modal-dialogs-container">
    <div aza-rws-modal-dialog-overlay class="modal-dialog-overlay display-none"></div>
    <div aza-rws-modal-dialog class="modal-dialog-centered display-none">
        <div aza-rws-modal-dialog-title class="modal-dialog-title"></div>
        <div aza-rws-modal-dialog-text class="modal-dialog-text"></div>
        <div aza-rws-modal-dialog-buttons class="modal-dialog-buttons">
            <section aza-rws-modal-dialog-first-button-container
                class="aza-rws-modal-dialog-first-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-first-button class="modal-dialog-button">
                    </button>
                </div>
            </section>
            <section aza-rws-modal-dialog-second-button-container
                class="aza-rws-modal-dialog-second-button-container aza-rws-modal-dialog-button-container display-none">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-second-button class="modal-dialog-button">
                    </button>
                </div>
            </section>
            <section aza-rws-modal-dialog-third-button-container
                class="aza-rws-modal-dialog-third-button-container aza-rws-modal-dialog-button-container display-none">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-third-button class="modal-dialog-button">
                    </button>
                </div>
            </section>
        </div>
    </div>

    <div aza-rws-enter-email-dialog class="modal-dialog-centered display-none">
        <div aza-rws-modal-dialog-title class="modal-dialog-title">
            <span aza-rws-enter-email-title-text translate>RESET_PASSWORD</span>
        </div>
        <div aza-rws-modal-dialog-text class="modal-dialog-text"></div>
        <section aza-rws-enter-email-container
            class="enter-email-container aza-theme aza-section section-form-single-column">
            <div class="enter-email-email-container">
                <label for="enter-email-email" class="enter-email-email-label" translate>ENTER_YOUR_EMAIL</label>
                <input aza-rws-enter-email-email name="enter-email-email" class="enter-email-email" />
            </div>
            <div aza-rws-enter-email-email-error-text-container
                class="enter-email-email-error-text aza-field-validation-error display-none">
                <span translate>PLEASE_ENTER_VALID_EMAIL_ADDRESS</span>
            </div>
        </section>
        <div aza-rws-modal-dialog-buttons class="modal-dialog-buttons">
            <section aza-rws-modal-dialog-first-button-container
                class="aza-rws-modal-dialog-first-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-first-button class="modal-dialog-button">
                        <span translate>CANCEL</span>
                    </button>
                </div>
            </section>
            <section aza-rws-modal-dialog-second-button-container
                class="aza-rws-modal-dialog-second-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-second-button class="modal-dialog-button">
                        <span translate>PROCEED</span>
                    </button>
                </div>
            </section>
        </div>
    </div>

    <div aza-rws-email-code-dialog class="modal-dialog-centered display-none">
        <div aza-rws-modal-dialog-title class="modal-dialog-title"></div>
        <div aza-rws-modal-dialog-text class="modal-dialog-text"></div>
        <section aza-rws-email-code-container
            class="email-code-container aza-theme aza-section section-form-single-column">
            <div class="email-code-description">
                <strong translate>AN_EMAIL_WITH_VERIFICATION_HAS_BEEN_SENT_TO_YOU_PLEASE_CHECK_YOUR_INBOX</strong>
            </div>
            <div class="email-code-description">
                <span translate>EMAIL_CONFIRMATION_CODE_SENT</span>
            </div>
            <div class="email-verification-code-container">
                <div aza-block-container="" class="section-form-single-column aza-section aza-theme aza-form">
                    <div class="aza-section-content aza-section-colors">
                        <div class="aza-form-field-area">
                            <div aza-block-container="" aza-input-required=""
                                class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-text">
                                    <label class="aza-text" translate>VERIFICATION_CODE</label>
                                    <input aza-rws-email-code type="text" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div aza-rws-modal-dialog-buttons class="modal-dialog-buttons">
            <section aza-rws-modal-dialog-first-button-container
                class="aza-rws-modal-dialog-first-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-first-button class="modal-dialog-button">
                        <span translate>CANCEL</span>
                    </button>
                </div>
            </section>
            <section aza-rws-modal-dialog-second-button-container
                class="aza-rws-modal-dialog-second-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-second-button class="modal-dialog-button">
                        <span translate>PROCEED</span>
                    </button>
                </div>
            </section>
        </div>
    </div>

    <div aza-rws-add-to-event-dialog class="modal-dialog-centered display-none">
        <div aza-rws-modal-dialog-title class="modal-dialog-title">
            <span translate>ADD_TO_EVENT</span>
        </div>
        <div aza-rws-modal-dialog-text class="modal-dialog-text"></div>
        <section aza-rws-add-to-event-container
            class="add-to-event-container aza-theme aza-section section-form-single-column aza-align-items-baseline">
            <span class="add-to-event-email-label" translate>EMAIL</span>
            <input aza-rws-add-to-event-email-input type="email" class="add-to-event-email" />
            <div aza-rws-add-to-event-email-input-field-validation-error class="aza-field-validation-error"></div>
        </section>
        <div aza-rws-modal-dialog-buttons class="modal-dialog-buttons">
            <section aza-rws-modal-dialog-first-button-container
                class="aza-rws-modal-dialog-first-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-first-button class="modal-dialog-button">
                        <span translate>CANCEL</span>
                    </button>
                </div>
            </section>
            <section aza-rws-modal-dialog-second-button-container
                class="aza-rws-modal-dialog-second-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-second-button
                        class="modal-dialog-button aza-rws-add-to-event-dialog-add-to-event-button">
                        <span translate>ADD_TO_EVENT</span>
                    </button>
                </div>
            </section>
        </div>
    </div>

    <div aza-rws-invite-contact-dialog class="modal-dialog-centered display-none">
        <div aza-rws-modal-dialog-title class="modal-dialog-title">
            <span translate>INVITE_CONTACT</span>
        </div>
        <div aza-rws-modal-dialog-text class="modal-dialog-text"></div>
        <section aza-rws-invite-contact-container
            class="invite-contact-container aza-theme aza-section section-form-single-column aza-align-items-baseline">
            <span class="invite-contact-first-name-label" translate>FIRST_NAME</span>
            <input aza-rws-invite-contact-first-name-input class="invite-contact-first-name" />
            <span class="invite-contact-last-name-label" translate>LAST_NAME</span>
            <input aza-rws-invite-contact-last-name-input class="invite-contact-last-name" />
            <span class="invite-contact-email-label" translate>EMAIL</span>
            <input aza-rws-invite-contact-email-input type="email" class="invite-contact-email" />
        </section>
        <div aza-rws-modal-dialog-buttons class="modal-dialog-buttons">
            <section aza-rws-modal-dialog-first-button-container
                class="aza-rws-modal-dialog-first-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-first-button class="modal-dialog-button">
                        <span translate>CANCEL</span>
                    </button>
                </div>
            </section>
            <section aza-rws-modal-dialog-second-button-container
                class="aza-rws-modal-dialog-second-button-container aza-rws-modal-dialog-button-container">
                <div class="modal-dialog-button-container">
                    <button aza-rws-modal-dialog-second-button class="modal-dialog-button">
                        <span translate>PROCEED</span>
                    </button>
                </div>
            </section>
        </div>
    </div>

    <div aza-rws-image-cropper-dialog class="modal-dialog modal-dialog-image-cropper display-none">
        <div class="image-field-non-cropped-image-container">
            <img *ngIf="!showCropper" [src]="imgFieldSrc" class="image-field-non-cropped-image" />
        </div>
        <image-cropper *ngIf="showCropper" [imageChangedEvent]="cropperImageChangeEvent" [maintainAspectRatio]="true"
            [aspectRatio]="cropperAspectRatio" output="base64" format="png"
            (imageCropped)="onCropperImageCropped($event)" (imageLoaded)="onCropperImageLoaded()"
            (cropperReady)="onCropperReady($event)" [disabled]="imageCroppingDisabled"
            (loadImageFailed)="onCropperLoadImageFailed()" class="edit-mode-image-field-cropper">
        </image-cropper>
        <div class="cropper-controls-container">
            <input aza-rws-cropper-select-file-input-element type="file" style="display: none;" />
            <span aza-rws-image-field-control-select-file class="cropper-control cropper-control-select-file">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
                </svg>
            </span>
            <span [hidden]="!showCropButton" aza-rws-image-field-control-crop
                class="cropper-control cropper-control-crop">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z" />
                </svg>
            </span>
        </div>
        <div class="cropper-cancel-proceed-controls-container">
            <section class="aza-rws-modal-dialog-button-container">
                <div aza-rws-cropper-control-cancel class="cropper-cancel-button modal-dialog-button-container">
                    <button class="modal-dialog-button">
                        <span translate>CANCEL</span>
                    </button>
                </div>
            </section>
            <section class="aza-rws-modal-dialog-button-container">
                <div aza-rws-cropper-control-apply class="cropper-apply-button modal-dialog-button-container">
                    <button class="modal-dialog-button">
                        <span translate>APPLY</span>
                    </button>
                </div>
            </section>
        </div>
    </div>

    <div aza-rws-revere-checkout-dialog class="modal-dialog modal-dialog-revere-checkout full-screen display-none">
        <div *ngIf="revereCheckoutUrl" class="aza-rws-revere-checkout-container  aza-vertical-stack">
            <section class="section-title aza-section aza-theme">
                <div class="aza-section-content aza-title-line-container">
                    <span class="aza-title-line" translate>REVERE_PAYMENT</span>
                </div>
            </section>
            <div aza-alternate
                class="section-form-two-column aza-section aza-theme aza-form aza-rws-revere-checkout-form-container">
                <div class="aza-section-content aza-section-colors">
                    <div class="aza-form-field-area-wrapper">
                        <div class="aza-form-field-area">
                            <div aza-input-required class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-text">
                                    <label class="aza-text">{{'CARD_HOLDER_S_FIRST_NAME' | translate}}</label>
                                    <input aza-rws-revere-checkout-first_name-field name="first_name" type="text" />
                                    <div aza-rws-revere-checkout-first_name-field-validation-error
                                        class="aza-field-validation-error aza-rws-modal-dialog-validation-error display-none">
                                    </div>
                                </div>
                            </div>
                            <div aza-input-required class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-email">
                                    <label class="aza-text">{{'EMAIL' | translate}}</label>
                                    <input aza-rws-revere-checkout-email-field name="email" type="email" />
                                    <div aza-rws-revere-checkout-email-field-validation-error
                                        class="aza-field-validation-error aza-rws-modal-dialog-validation-error display-none">
                                    </div>
                                </div>
                            </div>
                            <div aza-input-required class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-text">
                                    <label class="aza-text">{{'EXPIRATION_DATE' | translate}}</label>
                                    <div id="ccexp" class="aza-revere-ccexp-container"></div>
                                    <div aza-rws-revere-checkout-ccexp-field-validation-error
                                        class="aza-field-validation-error aza-rws-modal-dialog-validation-error display-none">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="aza-form-field-area">
                            <div aza-input-required class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-text">
                                    <label class="aza-text">{{'CARD_HOLDER_S_LAST_NAME' | translate}}</label>
                                    <input aza-rws-revere-checkout-last_name-field name="last_name" type="text" />
                                    <div aza-rws-revere-checkout-last_name-field-validation-error
                                        class="aza-field-validation-error aza-rws-modal-dialog-validation-error display-none">
                                    </div>
                                </div>
                            </div>
                            <div aza-input-required class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-text">
                                    <label class="aza-text">{{'CREDIT_CARD_NUMBER' | translate}}</label>
                                    <div id="ccnumber" class="aza-revere-ccnumber-container"></div>
                                    <div aza-rws-revere-checkout-ccnumber-field-validation-error
                                        class="aza-field-validation-error aza-rws-modal-dialog-validation-error display-none">
                                    </div>
                                </div>
                            </div>
                            <div aza-input-required class="aza-input-field aza-input-required">
                                <div class="aza-field-content aza-field-type-number">
                                    <label class="aza-text">{{'CVV' | translate}}</label>
                                    <div id="cvv" class="aza-revere-cvv-container"></div>
                                    <div aza-rws-revere-checkout-cvv-field-validation-error
                                        class="aza-field-validation-error aza-rws-modal-dialog-validation-error display-none">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div aza-rws-revere-checkout-total-container class="aza-rws-revere-checkout-total-container">
                <section class="section-title aza-section aza-theme">
                    <div class="aza-section-content aza-title-line-container">
                        <span class="aza-title-line">{{'TOTAL_AMOUNT' | translate}}:</span>
                    </div>
                </section>
                <section aza-alternate="sectiontype-text-centered"
                    class="section-text-one-column aza-section aza-theme sectiontype-text-centered">
                    <div class="aza-section-content aza-section-colors">
                        <div class="aza-text">
                            <span class="aza-rws-revere-checkout-total-value"
                                aza-rws-revere-checkout-total-value></span>
                            <span>&nbsp;</span>
                            <span class="aza-rws-revere-checkout-currency-value"
                                aza-rws-revere-checkout-currency-value></span>
                        </div>
                    </div>
                </section>
            </div>
            <div aza-rws-modal-dialog-buttons class="modal-dialog-buttons">
                <section class="aza-rws-modal-dialog-button-container">
                    <div class="modal-dialog-button-container">
                        <section class="section-form-button aza-section aza-theme aza-horizontal-stack">
                            <div class="aza-section-content aza-section-colors">
                                <button aza-rws-modal-dialog-first-button class="aza-button aza-section-inverted-colors"
                                    translate>CANCEL</button>
                            </div>
                            <div class="aza-section-content aza-section-colors">
                                <button aza-rws-modal-dialog-second-button
                                    class="aza-button aza-section-inverted-colors" translate>PROCEED</button>
                            </div>
                        </section>
                    </div>
                </section>
            </div>
        </div>
    </div>

    <div class="aza-rws-multi-registration-component-container display-none" id="aza-rws-multi-registration-component-container">
        <aza-rws-multi-registration
            *ngIf="eventParticipantFields"
            [allParticipantFields]="eventParticipantFields"
            [eventParticipant]="updatedEventParticipant | apply: getMergedUpdatedEventParticipant"
            [eventSettings]="eventSettings"
        ></aza-rws-multi-registration>
    </div>
</div>

<aza-rws-popup-template-container></aza-rws-popup-template-container>
